// components/HeaderRouter.jsx
import React from 'react';
import CommonHeader from './CommonHeader';
import StudentHeader from './StudentHeader';
import ParentHeader from './ParentHeader';
import SchoolHeader from './SchoolHeader';
import { useUser } from '../context/UserContext';
import StudentHeaderV2 from './StudentHeaderV2';

const HeaderRouter = () => {
    const { user } = useUser();
    // 1. Case: User is not logged in or session is null
    if (!user) {
        return <CommonHeader />;
    }

    // 2. Case: Logged in user is a student
    if (user.role === 'student') {
        return <StudentHeaderV2 />
        // return <StudentHeader studentName={user.username} points={user.points} />;
    }

    // 3. Case: Logged in user is a parent
    if (user.role === 'parent') {
        return <ParentHeader parentName={user.username} />;
    }

    if (user.role === 'school') {
        return <SchoolHeader studentId={user.studentId} />;
    }

    // Fallback default header
    return <CommonHeader />;
};

export default HeaderRouter;